import axios from "../../../axios";

export const addToWisshList = (id: any) => {
  const response = axios.post(`products/wishlist/add/${id}/`);
  return response;
};

export const removeFromWishList = (id: any) => {
  const response = axios.post(`products/wishlist/remove/${id}/`);
  return response;
};
export const getWishList = () => {
  const response = axios.post(`/products/wishlist/`);
  return response;
};
